import React, { FC, memo } from 'react'
import { List } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/List'
import { SpecialOffer } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/SpecialOffer'
import { NewDishes } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/NewDishes'
import { LookAlso } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/LookAlso'
import { Selection } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Selection'
import { MapMobile } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/MapMobile'
import { GoThisWeek } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/GoThisWeek'
import { GigAssist } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/GigAssist'
import { TypeAdvertisingCardRestVariety } from '@shared/api/analytics/advertising/advertising'
import { PickAnalytic } from '@shared/api/analytics/types/types'
import Booking from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Booking/Booking'
import { TemplateCardProps } from '@widgets/Restaurant/RestCards/RestCard/type/TemplateCardProps'

// list - Обычные списки
// special-offer - Спецпредложения
// new-dishes - Новые блюда
// look-also - Смотрите также
// selection - Подборки
// map - карточка на карте
// go-this-week - куда пойти на этой неделе
// booking - бронируйте прямо сейчас

// Секция в котором расположена карточка.
// Если это промо-карточка, то отправляется аналитика
export interface TypeAnalytic extends PickAnalytic<'section_name', 'section_index'> {
  advertCardPlaceType: TypeAdvertisingCardRestVariety | null
}

const componentsByType = {
  list: List,
  'special-offer': SpecialOffer,
  'new-dishes': NewDishes,
  'look-also': LookAlso,
  selection: Selection,
  'map-mobile': MapMobile,
  'go-this-week': GoThisWeek,
  booking: Booking,
  'gig-assist': GigAssist,
}

const RestCard: FC<TemplateCardProps> = ({
  type,
  data,
  analytic,
  sizes = 'L',
  className = '',
  send_analytic,
  link,
  onClickInsteadLink,
  ...props
}) => {
  const Template = componentsByType[type]

  return (
    <Template
      type={type}
      analytic={analytic}
      data={data}
      sizes={sizes}
      className={className}
      send_analytic={send_analytic}
      link={link}
      onClickInsteadLink={onClickInsteadLink}
      {...props}
    />
  )
}

export default memo(RestCard)
